/**
 * Canonical address type used across the application.
 * All internal address handling should use this shape.
 * Normalize from external formats (Grid API, sales drafts) using `normalizeAddress()`.
 */
export type Address = {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    street?: string;
    zipCode?: string;
    city?: string;
    country?: string;
    countryCode?: string;
};

/**
 * Loose input type that accepts any known address shape.
 * All fields are optional so both snake_case and camelCase variants can be passed directly.
 */
export type AddressLike = Address & {
    line1?: string;
    line2?: string;
    line3?: string;
    zip?: string;
    zip_code?: string;
    country_code?: string;
};

/**
 * Normalizes any known address shape to the canonical Address type.
 * Accepts both snake_case (Grid API, sales drafts) and camelCase (CustomerAddressDTO) formats.
 */
export function normalizeAddress(input: AddressLike): Address {
    return {
        addressLine1: input.addressLine1 ?? input.line1,
        addressLine2: input.addressLine2 ?? input.line2,
        addressLine3: input.addressLine3 ?? input.line3,
        street: input.street,
        zipCode: input.zipCode ?? input.zip ?? input.zip_code,
        city: input.city,
        country: input.country,
        countryCode: input.countryCode ?? input.country_code,
    };
}
